import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import PieChart from "../charts/generic/PieChart"

function DirectReports({ exportEndpoint, appliedFilters, data }) {
  const titleKey = "Widgets.DirectReports.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.DirectReports.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
    >
      <PieChart data={data} singularTooltipDescriptorKey="Common.Person" pluralTooltipDescriptorKey="Common.People" titleKey={titleKey}/>
    </Widget>
  )
}

DirectReports.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      key: PropTypes.string
    })
  ).isRequired,
  exportEndpoint: PropTypes.string.isRequired
}

export default DirectReports



// WEBPACK FOOTER //
// ./src/components/widgets/DirectReports.jsx